// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","link":"Footer_link__sgKeT","donateRow":"Footer_donateRow__K+P6O","donateForm":"Footer_donateForm__2CtZ1"};